<div class="containers page_container">
    <form class="left_container" [formGroup]="form">
        <div class="field field_search">
            <input class="input_search" type="text" [placeholder]="'companies.search_company'|translate" [formControl]="nameControlLocation" *ngIf="isCurrentStep(0)">
            <input class="input_search" type="text" [placeholder]="'Catalogs.search_catalogs'|translate" [formControl]="nameControleCatalog" *ngIf="isCurrentStep(1)">
            <input class="input_search" type="text" [placeholder]="'inventory.search_prod'|translate" [formControl]="nameControleProduct" *ngIf="isCurrentStep(2)">
            <img class="search_icon" src="assets/icones/search.svg" alt="">
        </div>
        <div class="filters">
            <div class="head">
                <img class="filter_icon" src="assets/icones/filter.svg" alt="">
                <h4 class="size_weight_color1 fs-medium m-0">{{"common.filters"|translate}}</h4>
            </div>
            <ng-container *ngIf="isCurrentStep(0)">
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_total_price"|translate}}</label>
                        <input type="text" formControlName="minTotalPrice">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_total_price"|translate}}</label>
                        <input type="text" formControlName="maxTotalPrice">
                    </div>
                </div>
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_total_sales"|translate}}</label>
                        <input type="text" formControlName="minTotalSales">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_total_sales"|translate}}</label>
                        <input type="text" formControlName="maxTotalSales">
                    </div>
                </div>
                <div class="fields">
                    <div class="field">
                        <label for="stock-Min">{{"quotations_and_orders.order_start_date"|translate}}</label>
                        <input type="datetime-local" formControlName="startDateTime">
                    </div>
                    <div class="field">
                        <label for="stock-Max">{{"quotations_and_orders.order_end_date"|translate}}</label>
                        <input type="datetime-local" formControlName="endDateTime">
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="isCurrentStep(1)">
                <mat-slide-toggle formControlName="isMultiBrands">Multi Brand</mat-slide-toggle>
                <mat-slide-toggle formControlName="isMonoBrands">Mono Brand</mat-slide-toggle>
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_nbr_sku"|translate}}</label>
                        <input type="text" formControlName="minNbrOfSKU">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_nbr_sku"|translate}}</label>
                        <input type="text" formControlName="maxNbrOfSKU">
                    </div>
                </div>
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_discount"|translate}}</label>
                        <input type="text" formControlName="minDiscount">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_discount"|translate}}</label>
                        <input type="text" formControlName="maxDiscount">
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="isCurrentStep(2)">
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_stock"|translate}}</label>
                        <input type="text" formControlName="minStock">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_stock"|translate}}</label>
                        <input type="text" formControlName="maxStock">
                    </div>
                </div>
                <div class="fields">
                    <div class="field">
                        <label for="price-Min">{{"quotations_and_orders.min_price"|translate}}</label>
                        <input type="text" formControlName="minPrice">
                    </div>
                    <div class="field">
                        <label for="price-Max">{{"quotations_and_orders.max_price"|translate}}</label>
                        <input type="text" formControlName="maxPrice">
                    </div>
                </div>
                <div class="field">
                    <label for="brands">{{ "brands.brands" | translate }}</label>
                    <select id="brands" formControlName="brands">
                      <option disabled selected value>
                        {{ "brands.all_brands" | translate }} ({{ brands?.length ?? 0 }})
                      </option>
                      <option *ngFor="let brand of brands" [value]="brand.id">
                        {{ brand.name }}
                      </option>
                    </select>
                  </div>

                  <div class="field">
                    <label for="categories">{{ "Categories.categories" | translate }}</label>
                    <select id="categories" formControlName="categories">
                      <option disabled selected value>
                        {{ "Categories.all_categories" | translate }} ({{ categories?.length ?? 0 }})
                      </option>
                      <option *ngFor="let category of categories" [value]="category.id">
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
            </ng-container>
            <div class="fields">
                <div class="field">
                    <a class="clear" (click)="clearFilters()">{{"quotations_and_orders.clear_filter"|translate }}</a>
                </div>
                <div class="field">
                    <button class="cancel_btn_pop_up filter_btn" (click)="applyFilter()" *ngIf="isCurrentStep(0)">{{"common.apply"|translate}}</button>
                    <button class="cancel_btn_pop_up filter_btn" (click)="applyFilter()" *ngIf="isCurrentStep(1)">{{"common.apply"|translate}}</button>
                    <button class="cancel_btn_pop_up filter_btn" (click)="applyFilter()" *ngIf="isCurrentStep(2)">{{"common.apply"|translate}}</button>
                </div>
            </div>
        </div>
    </form>
    <div class="right_container">
        <mat-stepper class="stepper_upload_processing add-quotation" #stepper>

            <mat-step [label]="'Catalogs.company_location' | translate | uppercase" *ngIf="locations$ | async as locations">
                <div class="head_table2 df">
                    <span class="black"><span class="bold2">{{locations?.length}}</span> {{"Catalogs.company_location"|translate}} </span>
                </div>
                <div class="list">
                    <table>
                        <tr class="tr">
                            <th>{{"companies.full_name_id"|translate}}</th>
                            <th class="number_clmn">{{"Catalogs.catalogs"|translate}}</th>
                            <th class="number_clmn">{{"companies.total_orders"|translate}}</th>
                            <th class="number_clmn">{{"companies.total_sales"|translate}}</th>
                            <th>{{"companies.last_order"|translate}}</th>
                            <th>{{"common.select"|translate}}</th>
                        </tr>
                        <ng-container *ngFor="let location of FiltredLocations(locations)">
                            <tr class="tr" [ngClass]="{'disabled_tr': location.nbr_catalogs === 0}">
                                <td>
                                    <div class="company_block">
                                        <span class="truncate company_name">
                                            {{location.company_name + ' - ' + location.name}}
                                        </span>
                                        <span
                                            *ngIf="location.provenance?.source === 'volta'"
                                            class="volta-location-icon"
                                            [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
                                            matTooltipClass="product-status-tooltip volta-location-tooltip"
                                            matTooltipPosition="above"
                                        >
                                            <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
                                        </span>
                                        <span class="truncate company_location_info">
                                            {{location.apartment}}
                                        </span>
                                        <span>
                                            ID: {{location.company_id || 'N/A'}}
                                        </span>
                                    </div>
                                </td>
                                <td class="number_clmn">{{location.nbr_catalogs}}</td>
                                <td class="number_clmn">{{location.total_orders_count}}</td>
                                <td class="number_clmn">
                                    <span class="bold">{{location.total_orders_amount | number:'1.2-2'}}€</span>
                                </td>
                                <td>
                                    <div class="">
                                        <span class="bold">{{location.last_order ? (location.last_order | adaptToUserUtcOffset | date: DATE_FORMAT) : '--'}}</span><br />
                                        <!-- <span>{{location.last_order! | daysAgoOrLeft}}</span> -->
                                    </div>
                                </td>
                                <td>
                                    <span class="tag bold selected" (click)="getCatalogs(location)">{{"common.select"|translate}}
                                        <img src="assets/icones/double-right-arrow.svg" alt="">
                                    </span>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
                <div class="foter_buttons">
                    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
                        <span>{{"common.back"|translate | uppercase}}</span>
                        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
                    </button>
                </div>
            </mat-step>
            <mat-step [label]="'Catalogs.catalogs' | translate | uppercase" *ngIf="catalogs$ | async as catalogs">
                <div class="head_table2">
                    <h4 class="bold2 m-0">{{currentLocatonName}}</h4>
                    <span class="black"><span class="bold2">{{catalogs?.length}}</span>{{"Catalogs.total_catalogs"|translate}}</span>
                </div>
                <div class="list">
                    <table>
                        <tr class="tr2">
                            <th>Picture</th>
                            <th>{{"common.name"|translate}}</th>
                            <th class="number_clmn">{{"quotations_and_orders.number_of_sku"|translate}}</th>
                            <th class="number_clmn">{{"quotations_and_orders.overall_discount"|translate}}</th>
                            <th class="number_clmn">{{"quotations_and_orders.nbr_of_brand"|translate}}</th>
                            <th>{{"common.select"|translate}}</th>
                        </tr>
                        <ng-container *ngFor="let catalog of filtredCatalogs(catalogs)">
                            <tr class="tr2" [ngClass]="{'disabled_tr': disableCatalog(catalog)}">
                                <td>
                                    <div class="img_product">
                                        <img [src]="catalog.image ? baseUrl + catalog.image + '?thumbnail=1' : placeholder" alt="">
                                    </div>
                                </td>
                                <td (click)="getProducts(catalog)" style="cursor: pointer;">{{catalog.name}}</td>
                                <td class="number_clmn">
                                    <span class="bold">{{catalog.nbr_products}}</span>
                                </td>
                                <td class="number_clmn">
                                    <div class="">
                                        <span class="bold">{{catalog.general_discount}}</span>
                                    </div>
                                </td>
                                <td class="number_clmn">{{catalog.nbr_brands}}</td>
                                <td>
                                    <span class="tag bold selected" (click)="getProducts(catalog)">{{"common.select"|translate}}
                                        <img src="assets/icones/double-right-arrow.svg" alt="">
                                    </span>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
                <div class="foter_buttons">
                    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
                        <span>{{"common.back"|translate | uppercase}}</span>
                        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
                    </button>
                </div>
            </mat-step>
            <mat-step [label]="'quotations_and_orders.product' | translate | uppercase">
                <div class="head_table2 df space-b">
                    <div class="df gap-25">
                        <span class="black"><span class="bold2">{{productsSelected()}}</span> {{"quotations_and_orders.product_selected"|translate }}</span>
                        <span class="black"><span class="bold2">{{totalQuantity()}}</span> {{"quotations_and_orders.quantity"|translate}}</span>
                        <span class="black"><span class="bold2">{{totalPrice() | number:'1.2-2'}} {{getCurrencySymbol()}}</span> {{"quotations_and_orders.subtotal"|translate}}</span>
                    </div>
                    <div class="df gap-10">
                        <div class="standard-input standard-input-currency">
                            <mat-select [formControl]="currencyControl">
                              <mat-option *ngFor="let currency of currentCatalogCurrencies" [value]="currency.id">{{ currency.name }}</mat-option>
                            </mat-select>
                        </div>
                        <mat-slide-toggle class="toggle_final" [(ngModel)]="isFinalQuote"></mat-slide-toggle>
                        <div class="df gap-10">
                            <img class="icon1" src="assets/icones/final-quote.svg" alt="">
                            <span class="fn_quote">{{"quotations_and_orders.final_quote"|translate}}</span>
                        </div>
                        <div class="hint-container">
                            <img class="hint_icon" src="../../../../../assets/icones/hint.svg" alt="">
                            <span class="hint_descr">{{"quotations_and_orders.when_select"|translate}}</span>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <table [formGroup]="productsForm">
                        <tr class="head_title tr3">
                            <th>
                                <mat-checkbox #checkBox class="example-margin" (change)="checkAllProducts($event)" [disabled]="allProductsDisable()" [checked]="isAllChecked()"></mat-checkbox>
                                <span class="ml-10">{{"common.image"|translate}}</span>
                            </th>
                            <th style="line-height: 13px !important;">
                                <div>
                                    {{"common.name"|translate}}<br>
                                    <span class="gray">{{ productCode.primaryLabelKey | translate }}</span>
                                </div>
                            </th>
                            <th class="number_clmn">{{"inventory.stock"|translate}}</th>
                            <th class="number_clmn">{{"quotations_and_orders.quantity"|translate}}</th>
                            <th class="number_clmn">{{"Catalogs.retail_price"|translate}}</th>
                            <th class="number_clmn">{{"Catalogs.mark_up"|translate}}</th>
                            <th class="number_clmn">{{"Catalogs.discount"|translate}}</th>
                            <th class="number_clmn">{{"Catalogs.final_price"|translate}}</th>
                        </tr>
                        <ng-container *ngFor="let product of currentFilter">
                            <tr class="tr3 ng-star-inserted" [ngClass]="{ 'disabled_tr': shouldDisableProductLine(product)}">
                                    <td>
                                        <mat-checkbox class="example-margin" [disabled]="shouldDisableProductLine(product)" [(ngModel)]="product.checked" [ngModelOptions]="{standalone: true}" (change)="checkProduct(product, $event)"></mat-checkbox>
                                        <div class="img_product ml-10">
                                            <img [src]="product.image ? baseUrl + product.image + '?thumbnail=1' : placeholder" alt="">
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            {{product.name}}
                                            <br>
                                            <span class="gray">{{product | productCode}}</span>
                                        </div>
                                        <!-- <div [tooltip]="'.killing_stock_details'" [offsetLeft]="30" [offsetTop]="66" [maxWidth]="'400px'" *ngIf="isKillingStock(product) && product.is_owned">
                                          <span class="killing_stock_msg">{{"quotations_and_orders."+killingStockMessage(product)+".label"| translate}}</span>
                                          <div class="tooltip-content">
                                              <div class="killing_stock_details">
                                                  {{ "quotations_and_orders."+killingStockMessage(product)+".details" | translate}}
                                              </div>
                                          </div>
                                        </div> -->
                                    </td>
                                    <td class="number_clmn">
                                        <ng-container *ngIf="product?.is_owned === false; else owned">
                                            <span class="tag">
                                                {{'inventory.notOwned' | translate}}
                                            </span>
                                            </ng-container>
                                            <ng-template #owned>
                                                <div>
                                                {{product.stock?.quantity}}
                                                </div>
                                            </ng-template>
                                    </td>
                                    <td class="number_clmn">
                                        <div>
                                            <input type="number" class="input" [formControlName]="'quantity_' + product.product_id" [class]="productsForm.get('quantity_' + product.product_id)?.errors ? 'invalid' : ''" (input)="updateQuantity($event, product)">
                                            <!-- <div class="exceeded_stock_msg" *ngIf="isKillingStock(product) && product.is_owned">{{"quotations_and_orders.stock_exceeded" | translate: {exceeded_stock: exceededStock(product)} }}</div> -->
                                            <div *ngIf="productsForm.get('quantity_' + product.product_id)?.errors">
                                                <span class="error-message">
                                                  {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityInvalid'] }}
                                                  {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityMin'] }}
                                                  {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityMax'] }}
                                                  {{ productsForm.get('quantity_' + product.product_id)?.errors?.['quantityIncrement'] }}
                                                </span>
                                            </div>
                                            <div class="item last_td hint">
                                                <span>{{"quotations_and_orders.quantity_rule"|translate}}</span>
                                                <button mat-button [matMenuTriggerFor]="menu">
                                                    <img src="assets/icones/rule.svg" alt="" class="info_hint">
                                                </button>
                                                <mat-menu xposition="after" #menu="matMenu">
                                                    <div class="cover_div">
                                                        <div class="info_hint">
                                                            <span>{{"quotations_and_orders.quantity_rule"|translate}}</span>
                                                        </div>
                                                        <div class="spans">
                                                            <span>{{"Catalogs.min"|translate}} : {{product.min_qte}}</span>
                                                            <span>{{"Catalogs.max"|translate}} : {{product.max_qte}}</span>
                                                            <span>{{"Catalogs.increment"|translate}} : {{product.increment}}</span>
                                                        </div>
                                                    </div>
                                                </mat-menu>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="number_clmn">
                                        {{product.price_unit ? product.price_unit + getCurrencySymbol() : '--'}}
                                    </td>
                                    <td class="number_clmn">
                                        {{product.price_unit ? ((productsForm.get('final_price_' + product.product_id )?.value) - product.cost) + getCurrencySymbol() : '--' }}
                                    </td>
                                    <td class="number_clmn">
                                        <div class="last_td" *ngIf="product.price_unit">
                                            <input [value]="product.discount" type="number" class="input" [disabled]="!product.checked" (input)="updateDiscount($event, product)" title="">
                                            <span class="indicate_input">%</span>
                                        </div>
                                    </td>
                                    <td class="number_clmn">
                                        <div [style]="{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'end'
                                        }"  >
                                          <div class="last_td" [style]="{
                                            width: '72px'
                                          }">
                                            <input [formControlName]="'final_price_' + product.product_id" type="number" class="input" [style]="{
                                              width: '100%',
                                              boxSizing: 'border-box'
                                            }" [disabled]="!product.checked" (input)="updateFinalPrice($event, product)">
                                            <span class="indicate_input">{{getCurrencySymbol()}}</span>
                                          </div>
                                          <span class="error_ms" *ngIf="productsForm.get('final_price_' + product.product_id )?.touched  && productsForm.get('final_price_' + product.product_id )?.errors">
                                              {{"common.required_field" | translate}}
                                            </span>
                                        </div>
                                    </td>
                            </tr>
                            <tr *ngIf="isStockAlert(product)">
                                <td colspan="10" style="padding: 0 !important;">
                                    <div [class]="alertType(product)" class="alert_div">
                                        <div class="alert_div_content" [tooltip]="'.killing_stock_details'" [offsetLeft]="30" [offsetTop]="66" [maxWidth]="'400px'">
                                            <img *ngIf="alertType(product) === 'alert_div_danger'" src="assets/icones/alert_icon.svg" alt="alert-icon">
                                            <img *ngIf="alertType(product) === 'alert_div_warning'" src="assets/icones/warning_icon.svg" alt="alert-icon">
                                            <span class="alert-message">{{alertMessage(product) + '.label' | translate}}</span>
                                            <div class="tooltip-content">
                                                <div class="killing_stock_details">
                                                    {{ alertMessage(product) + '.details' | translate}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>

                    </table>
                </div>
                <div class="foter_buttons">
                    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
                        <span>{{"common.back"|translate | uppercase}}</span>
                        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
                    </button>
                    <button class="save_btn_pop_up blue_btn" (click)="SendQuotation('Draft')">
                        <span>{{"common.create_draft_order" |translate | uppercase}}</span>
                        <img alt="" src="assets/icones/arrow_circle_right.svg">
                      </button>
                </div>
            </mat-step>
        </mat-stepper>
    </div>
</div>
